class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if(!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      //this.toggleAddButton(false, '', false);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions(){
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if(element.tagName === 'SELECT') {
        return element.value;
      }
      if(element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
          return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;
    if(tagName === 'SELECT' && target.selectedOptions.length) {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if(selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    } else if(tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if(selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia(){
    if(!this.currentVariant) return;
    if(!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
     mediaGalleries.forEach((mediaGallery) => {
       var activeSl = mediaGallery.querySelector('.primgSlider .swiper-slide-active'),
         crmedia = 0;
       if(activeSl) crmedia = activeSl.dataset.id;
       if(crmedia != `${this.currentVariant.featured_media.id}` || Shopify.designMode){
          mediaGallery.setActiveMedia(`${this.currentVariant.featured_media.id}`, true);
       }
     });
  }

  updateURL(){
    if(!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl(){
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if(!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput(){
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const BackInStock = document.querySelector(`#backInStock-${this.dataset.section}`);
    if(BackInStock) BackInStock.checkBackinstock(this.currentVariant);
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if(index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if(element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if(element.tagName === 'OPTION') {
        element.classList.toggle('disabled', !availableElement);
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if(!section) return;
    const productForm = section.querySelector('product-form');
    if(productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(){
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    document.querySelectorAll("#stickyOptions option").forEach((option) => {
      if(option.value === this.currentVariant.title) option.selected = true;
    });
    
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text()).then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if(this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const volumePricingSource = html.getElementById(`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`),
          stickyData = document.querySelector('sticky-cart .stickyData'),
          stickyDataSource = html.querySelector('sticky-cart .stickyData');

        if(volumeNote) volumeNote.classList.remove('hidden');
        if(volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if(qtyRules) qtyRules.classList.remove('hidden');

        if(source && destination) destination.innerHTML = source.innerHTML;
        if(inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if(skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if(volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if(pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if(price) price.classList.remove('hidden');

        if(inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        if(stickyData && stickyDataSource) stickyData.innerHTML = stickyDataSource.innerHTML;

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-info span.money, .stPrice span.money'));
        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: { sectionId, html, variant: this.currentVariant, },
        });
      });
  }

  toggleAddButton(disable = false, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if(!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if(!addButton) return;

    if(disable){
      addButton.setAttribute('disabled', 'disabled');
      if(text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      var vr = `data-v${this.currentVariant.id}`,
        qty = document.querySelector('.prvQty').getAttribute(vr);
      if(qty < 1 && this.currentVariant.inventory_management == "shopify"){
        addButtonText.textContent = window.variantStrings.preOrder;
      } else{
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }
    if(!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if(!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if(price) price.classList.add('hidden');
    if(inventory) inventory.classList.add('hidden');
    if(sku) sku.classList.add('hidden');
    if(pricePerItem) pricePerItem.classList.add('hidden');
    if(volumeNote) volumeNote.classList.add('hidden');
    if(volumeTable) volumeTable.classList.add('hidden');
    if(qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

if(!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if(!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if(!this.quantityForm) return;
        this.setQuantityBoundries();
        if(!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if(event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if(this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if(this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if(max !== null) min = Math.min(min, max);
        if(data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if(!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if(!current || !updated) continue;
          if(selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if(valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if(this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
      
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if(this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".qtyBtn[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if(this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".qtyBtn[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function removeTrapFocus(elementToFocus = null){
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if(elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (e) => {
    if(e.target !== container && e.target !== last && e.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(e) {
    if(e.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if(e.target === last && !e.shiftKey) {
      e.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if((e.target === container || e.target === first) && e.shiftKey){
      e.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      e.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', debouncedOnChange.bind(this));
  }
  
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if(event.source === 'cart-items') {
        return;
      }
      // Skip if we're manually updating to prevent recursive updates
      if(window.__isManuallyUpdatingCart) {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if(this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }
  onCartUpdate() {
    if(this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text()).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for(const selector of selectors){
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if(targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      // For main cart items, use the improved refresh logic
      const isCartPage = window.location.pathname === '/cart';
      if (isCartPage) {
        // For cart page, use proper section requests
        const sectionsToRequest = ['cart-icon-bubble'];
        const mainCartItems = document.getElementById('main-cart-items');
        if (mainCartItems?.dataset.id) {
          sectionsToRequest.push(mainCartItems.dataset.id);
        }
        const mainCartFooter = document.getElementById('main-cart-footer');
        if (mainCartFooter?.dataset.id) {
          sectionsToRequest.push(mainCartFooter.dataset.id);
        }
        
        fetch(`/cart/update.js?sections=${sectionsToRequest.join(',')}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin"
        })
        .then((response) => response.json())
        .then((freshHtml) => {
          // Update main cart items
          if (mainCartItems && freshHtml.sections && freshHtml.sections[mainCartItems.dataset.id]) {
            const mainCartSection = freshHtml.sections[mainCartItems.dataset.id];
            const cartItemsElement = document.querySelector('cart-items');
            if (cartItemsElement?.getSectionInnerHTML) {
              const sectionHTML = cartItemsElement.getSectionInnerHTML(mainCartSection, '.js-contents');
              const elementToReplace = mainCartItems.querySelector('.js-contents') || mainCartItems;
              elementToReplace.innerHTML = sectionHTML;
            } else {
              mainCartItems.innerHTML = mainCartSection;
            }
          }
          
          // Update cart footer using helper function
          if (mainCartFooter && freshHtml.sections && freshHtml.sections[mainCartFooter.dataset.id]) {
            const footerSection = freshHtml.sections[mainCartFooter.dataset.id];
            updateCartFooter(mainCartFooter, footerSection);
          }
          
          // Trigger cart update events
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: freshHtml } }));
          if (typeof window.publish !== 'undefined') {
            window.publish('cart-updated', freshHtml);
          }
        })
        .catch((e) => {
          console.error('Cart page update error:', e);
          // Fallback to page reload
          window.location.reload();
        });
      } else {
        // Fallback to original logic for other contexts
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text()).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
      }
    }
  }

  getSectionsToRender(){
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cartTotal',
      }
    ];
  }

 updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if(parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if(cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if(cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if(items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if(typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if(lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if(parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if(document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        // Fix for cart page freeze: Ensure freeze-causing classes are removed when products are removed
        const isCartPage = window.location.pathname === '/cart';
        if (isCartPage) {
          // Remove of_hidden class to prevent page freeze
          document.documentElement.classList.remove('of_hidden');
          document.body.classList.remove('of_hidden');
          
          // Remove tingle-enabled class that causes overflow:hidden and freezes the page
          document.documentElement.classList.remove('tingle-enabled');
          document.body.classList.remove('tingle-enabled');
          
          // Additional safety: Remove any other classes that might cause overflow:hidden
          const freezeClasses = ['of_hidden', 'tingle-enabled', 'modal-open', 'popup-open'];
          freezeClasses.forEach(className => {
            document.documentElement.classList.remove(className);
            document.body.classList.remove(className);
          });
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        
        // Ensure freeze-causing classes are removed even on error
        const isCartPage = window.location.pathname === '/cart';
        if (isCartPage) {
          const freezeClasses = ['of_hidden', 'tingle-enabled', 'modal-open', 'popup-open'];
          freezeClasses.forEach(className => {
            document.documentElement.classList.remove(className);
            document.body.classList.remove(className);
          });
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if(lineItemError) lineItemError.querySelector('.ctItem-error').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    freeShippMsg();cartTerms();
    if(theme.mlcurrency) currenciesChange(document.querySelectorAll('cart-item span.money'));
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}
customElements.define('cart-items', CartItems);

if(!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('input',debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, 300)
        );
      }
    }
  );
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cartLink');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      const iscart = document.body.classList.contains('template-cart');
      if(!iscart) this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (e) => {
      if(e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if(triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if(cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    html.classList.add('of_hidden');
  }

  close() {
    this.classList.remove('active','poptop');
    removeTrapFocus(this.activeElement);
    html.classList.remove('of_hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (e) => {
      e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));
    });

    //cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement && parsedState.sections[section.id]) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('cart-item span.money'));
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section'){
    if (!html) return '';
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : '';
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

class CartDiscount extends HTMLElement {
  #activeFetch = null;
  constructor() {
    super();
    const form = this.querySelector("form");
    form.addEventListener("submit", this.applyDiscount);

    this.addEventListener("click", (event) => {
      if (event.target.closest(".cart-discount-remove")) {
        this.removeDiscount(event);
      }
    });
    this.submitButton = this.querySelector('[type="submit"]');
    this.errorEl = document.querySelector('.cart-discount__error') || document.querySelector('CartDrawer-discount__error');
  }

  #createAbortController() {
    if(this.#activeFetch) this.#activeFetch.abort();

    const abortController = new AbortController();
    this.#activeFetch = abortController;
    return abortController;
  }

  async #updateCartDiscount(discountCodes, abortController) {
    const body = JSON.stringify({discount: discountCodes.join(","), sections: this.getSectionsToRender().map((section) => section.section), sections_url: window.routes.cart_url,});
    console.log(body);
    const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: body, signal: abortController.signal } });
    return response.json();
  }

  #updateCartUI(data){
    // Update main cart sections
    this.getSectionsToRender().forEach((section) => {
      if (data.sections && data.sections[section.section]){
        const elementToReplace = document.getElementById(section.id) ?.querySelector(section.selector) || document.getElementById(section.id);
        if(elementToReplace){
          elementToReplace.innerHTML = this.getSectionInnerHTML(data.sections[section.section], section.selector);
        }
      }
    });
  }

  #setLoadingState(isLoading) {
    if (isLoading) {
      this.submitButton.setAttribute("aria-disabled", "true");
      this.submitButton.classList.add("loading");
      this.submitButton.querySelector('.loading__spinner').classList.remove("hidden");
    } else {
      this.submitButton.removeAttribute("aria-disabled");
      this.submitButton.classList.remove("loading");
      this.submitButton.querySelector('.loading__spinner').classList.add("hidden");
    }
  }

  /*** Returns an array of existing discount codes. * @returns {string[]} */
  #existingDiscounts() {
    const discountCodes = [];
    const discountPills = this.querySelectorAll(".discount-code, [data-discount-code]");

    for (const pill of discountPills){
      if (pill instanceof HTMLElement){
        const code = pill.dataset.discountCode || pill.dataset.code;
        if (typeof code === "string" && code.trim()) {
          discountCodes.push(code.trim());
        }
      }
    }
    return discountCodes;
  }
  applyDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.errorEl.classList.add('hidden');
    
    const form = event.target instanceof HTMLFormElement ? event.target : this.querySelector("form");
    const discountCode = form.querySelector('input[name="discount"]');
    const discountCodeValue = discountCode.value.trim();
    if(!discountCodeValue) return;

    // Check if discount already exists
    const existingDiscounts = this.#existingDiscounts();
    if (existingDiscounts.includes(discountCodeValue)){
      this.#handleDiscountError('exist');
      return;
    }

    this.#setLoadingState(true);
    const abortController = this.#createAbortController();

    try {
      const updatedDiscounts = [...existingDiscounts, discountCodeValue];
      const data = await this.#updateCartDiscount(updatedDiscounts, abortController);

      /** @type {{ code: string; applicable: boolean; }} */
      if(data.discount_codes.find((discount) => { return (discount.code === discountCodeValue && discount.applicable === false);})){
        this.#handleDiscountError('discount');
        return;
      }

      discountCode.value = "";
      this.#updateCartUI(data);
      //this.#checkShipCode(discountCodeValue,data.discount_codes);
    } catch (error) {
      var type = "applying discount"
      this.#handleDiscountError(type);
    } finally {
      this.#setLoadingState(false);
      this.#activeFetch = null;
    }
  };

  removeDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const removeButton = event.target.closest(".cart-discount-remove");
    removeButton.setAttribute("aria-disabled", "true");
    removeButton.classList.add("loading");
    if(event instanceof KeyboardEvent && event.key !== "Enter") return;

    const discountCode = this.#getDiscountCodeFromEvent(event);
    if(!discountCode) return;

    const existingDiscounts = this.#existingDiscounts();
    const updatedDiscounts = existingDiscounts.filter((code) => code !== discountCode);

    if(updatedDiscounts.length === existingDiscounts.length){
      console.warn("Discount code not found in existing discounts");
      return;
    }

    const abortController = this.#createAbortController();

    try {
      const data = await this.#updateCartDiscount(updatedDiscounts, abortController);
      this.#updateCartUI(data);
    } catch (error) {

    } finally {
      this.#activeFetch = null;
      removeButton.setAttribute("aria-disabled", "false");
      removeButton.classList.remove("loading");
      this.errorEl.classList.add('hidden');
    }
  };

  #getDiscountCodeFromEvent(event) {
    const removeButton = event.target.closest(".discount-code");
    if (!removeButton) return null;
    return (removeButton.dataset.code || removeButton.dataset.discountCode || removeButton.closest("[data-discount-code]")?.dataset.discountCode || null);
  }

  #checkShipCode(code, codes){
    const existingDiscounts = this.#existingDiscounts();
    if(!existingDiscounts.includes(code) && codes.find((discount) => { return (discount.code === code && discount.applicable === true);})){
      this.#handleDiscountError('shipping');
    }
  }
  /*** Handles the discount error. */
  #handleDiscountError(type){
    if(type == 'shipping'){
      this.errorEl.textContent = cartStrings?.discount_ship;
    } else if(type == 'exist'){
      this.errorEl.textContent = cartStrings?.discount_already;
    } else {
      this.errorEl.textContent = cartStrings?.discount_error;
    }
    this.errorEl.classList.remove('hidden');
  }

  getSectionsToRender(){
    const mainCartItems = document.getElementById("main-cart-items");
    if(mainCartItems){
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.cartTotal',
          },
          {
            id: 'cartDiscount',
            section: document.getElementById('cartDiscount').dataset.id,
            selector: '.cart-discount__codes',
          }
        ];
    } else {
       return [
          {
            id: 'CartDrawer',
            section: document.getElementById('cartDiscount').dataset.id,
            selector: '.drawer__inner'
          },
          {
            id: 'cartDiscount',
            section: document.getElementById('cartDiscount').dataset.id,
            selector: '.cart-discount__codes',
          }
        ];
    }
  }

  getSectionInnerHTML(html, selector) {
    return ( new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML || "" );
  }
}

if (!customElements.get("cart-discount")){
  customElements.define("cart-discount", CartDiscount);
}

class CartOption extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.cftBtn').forEach((button) => button.addEventListener("click", function(e){
        e.preventDefault()
        const allElements = document.querySelectorAll('.cftDraw')
        allElements.forEach(el => el.classList.remove('active'))
        var ftbk = this.hash.substr(1);
        document.getElementById(ftbk).classList.add("active");
    }));
  }
}
customElements.define('cart-option', CartOption);

document.querySelectorAll('.saveBtn').forEach((btn) => {
  btn.addEventListener('click',(e) => {
    e.preventDefault();
    [].forEach.call(document.querySelectorAll('.cftDraw'), function(dw){ dw.classList.remove("active"); });
  });
});

function startTimer(duration, display) {
    var timer = duration, minutes, seconds;
    setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if(--timer < 0) {
            clearInterval(startTimer);
            document.querySelector('.cartCountdown').remove();
        }
    }, 1000);
}
window.onload = function(){
    if(document.querySelector('.cartCountdown')){
        var minutes = document.querySelector('.cartCountdown').getAttribute('data-countdown'),
            display = document.querySelector('#cartTime');
        startTimer(minutes, display);
    }
};

if(!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if(document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const carePlanInput = document.querySelector('.care-plan-body input:checked');
        const engravingInput = document.querySelector('.engraving-input');
        const engravingText = engravingInput?.value?.trim() || '';
        const engravingVariantId = document.querySelector('.product-engraving')?.dataset?.engravingVariantId;
        
        // Check if engraving product exists and engraving text is entered
        const hasEngraving = engravingVariantId && engravingText;

        // Default body (normal products)
        let body = formData;
        let isJson = false;

        // Build JSON payload if care plan or engraving is selected
        if ((carePlanInput && carePlanInput.value) || hasEngraving) {
          const productTitle = document.querySelector('h1.rgTxt')?.innerText.trim() || '';
          const items = [];
          
          // Build main product properties - collect all properties from form
          const mainProductProperties = {};
          
          // Collect all properties from formData
          for (const [key, value] of formData.entries()) {
            if (key.startsWith('properties[') && key.endsWith(']')) {
              // Extract property name from "properties[Property Name]"
              const propertyName = key.slice(11, -1); // Remove "properties[" and "]"
              if (value && value.trim() !== '') {
                mainProductProperties[propertyName] = value;
              }
            }
          }
          
          // Override care plan property if selected (use dataset title)
          if (carePlanInput && carePlanInput.value) {
            mainProductProperties['Care Plan'] = carePlanInput.dataset.title;
          } else {
            mainProductProperties['Care Plan'] = null;
          }
          
          // Override engraving property if text is entered (use from input)
          if (hasEngraving) {
            mainProductProperties['Laser Engraving'] = engravingText;
          }
          
          // Add main product
          items.push({
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1,
            properties: mainProductProperties
          });
          
          // Add care plan product if selected
          if (carePlanInput && carePlanInput.value) {
            items.push({
              id: carePlanInput.value,
              quantity: formData.get('quantity') || 1,
              properties: { 'Care Plan For': productTitle }
            });
          }
          
          // Add engraving product if text is entered
          if (hasEngraving) {
            items.push({
              id: engravingVariantId,
              quantity: formData.get('quantity') || 1,
              properties: { 
                'Engraving For': productTitle,
                'Laser Engraving': engravingText
              }
            });
          }

          body = JSON.stringify({
            items: items,
            sections: this.cart ? this.cart.getSectionsToRender().map(s => s.id) : [],
            sections_url: window.location.pathname
          });

          isJson = true;
          config.headers['Content-Type'] = 'application/json';
        } else {
          // fallback for normal products
            // ensure a Care Plan property exists
          if (!formData.has('properties[Care Plan]')) {
            formData.append('properties[Care Plan]', ''); // add empty Care Plan
          }
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map(s => s.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = body;

  // Important: use /cart/add.js only when JSON, else /cart/add
        const addUrl = isJson ? `${routes.cart_add_url}.js` : `${routes.cart_add_url}`;

        fetch(addUrl, config)
          .then(res => res.json())
          .then(response => {
            if (response.status) {
              // Error case
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            if (!this.cart) {
              // fallback redirect
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response
            });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => this.cart.renderContents(response));
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch(err => console.error('Add to cart error:', err))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            freeShippMsg();
            cartTerms();
          });
      }


      handleErrorMessage(errorMessage = false) {
        if(this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if(!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if(errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function cartTerms(){
  var cterms = document.querySelector('#cartTerms'),
    cBtn = document.querySelector('.cartCheckout');
  if(cterms && cBtn){
    cterms.onchange = function(){
      cBtn.disabled = !this.checked;
    }
  }
}
cartTerms();

(function () {
  if (window.__wbCarePlanPatched) return;
  window.__wbCarePlanPatched = true;

  const originalFetch = window.fetch;

  // UTIL: query both theme syntaxes (cart drawer and main cart)
  const q = (sel) =>
    document.querySelector(`line-item${sel}`) ||
    document.querySelector(`[data-line-item]${sel}`) ||
    document.querySelector(`tr${sel}`) ||
    document.querySelector(`[data-line-number]${sel}`);

  function cssEscape(sel) {
    return String(sel).replace(/([:\\.\[\]#"])/g, "\\$1");
  }

  // Helper function to find paired product
  function findPairedProduct(currentKey, currentProductName, pairedWithProperty) {
    const allCartItems = document.querySelectorAll('[data-key]');
    
    for (const item of allCartItems) {
      if (item.getAttribute("data-key") !== currentKey) {
        const itemProperty = item.getAttribute("data-property");
        const otherProductName = item.querySelector('.pr_name')?.textContent?.trim() || 
                                 item.querySelector('.cart-item__name')?.textContent?.trim();
        
        // Verify bidirectional pairing to ensure correct match
        if (itemProperty === currentProductName && pairedWithProperty === otherProductName) {
          return item.getAttribute("data-key");
        }
      }
    }
    return null;
  }

  // Helper function to update cart footer correctly for both layout 1 and layout 2
  function updateCartFooter(mainCartFooter, footerSection) {
    if (!mainCartFooter || !footerSection) return;
    
    try {
      // Check if we're in layout 2 (grid layout) by looking for .cart_summery li
      const existingCartSummery = document.querySelector('.cart_summery');
      
      if (existingCartSummery) {
        // Layout 2: The cart summary is inside a <li class="cart_summery"> inside <ul class="cart_footer">
        // The footerSection contains the entire cart_summery capture (<div class="bdr-box">...</div>)
        // We need to replace the content of the .cart_summery li with the section HTML
        existingCartSummery.innerHTML = footerSection;
      } else {
        // Layout 1: The main-cart-footer is directly in the layout and contains the cart summary
        // Update it directly with the section HTML
        mainCartFooter.innerHTML = footerSection;
      }
    } catch (error) {
      console.warn('Error updating cart footer:', error);
      // Fallback: update the main-cart-footer directly
      mainCartFooter.innerHTML = footerSection;
    }
  }

  // Helper function to refresh cart UI
  async function refreshCartUI(cartEl) {
    try {
      const isCartPage = window.location.pathname === '/cart';
      const sectionsToRequest = [];
      
      if (isCartPage) {
        // For cart page, request main cart sections
        sectionsToRequest.push('cart-icon-bubble');
        const mainCartItems = document.getElementById('main-cart-items');
        if (mainCartItems?.dataset.id) {
          sectionsToRequest.push(mainCartItems.dataset.id);
        }
        const mainCartFooter = document.getElementById('main-cart-footer');
        if (mainCartFooter?.dataset.id) {
          sectionsToRequest.push(mainCartFooter.dataset.id);
        }
      } else {
        // For cart drawer, request drawer sections
        sectionsToRequest.push('cart-drawer', 'cart-icon-bubble');
      }
      
      if (sectionsToRequest.length === 0) {
        // Fallback to page reload if no sections to request
        window.location.reload();
        return;
      }
      
      const freshCartResponse = await originalFetch(`/cart/update.js?sections=${sectionsToRequest.join(',')}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin"
      });
      
      if (freshCartResponse.ok) {
        const freshHtml = await freshCartResponse.json();
        
        // Use requestAnimationFrame to reduce forced reflow
        requestAnimationFrame(() => {
          // Update cart drawer
          if (cartEl?.renderContents) {
            cartEl.renderContents(freshHtml);
          }
          
          // Update main cart page
          if (isCartPage) {
            const mainCartItems = document.getElementById('main-cart-items');
            if (mainCartItems && freshHtml.sections && freshHtml.sections[mainCartItems.dataset.id]) {
              const mainCartSection = freshHtml.sections[mainCartItems.dataset.id];
              const cartItemsElement = document.querySelector('cart-items');
              if (cartItemsElement?.getSectionInnerHTML) {
                const sectionHTML = cartItemsElement.getSectionInnerHTML(mainCartSection, '.js-contents');
                const elementToReplace = mainCartItems.querySelector('.js-contents') || mainCartItems;
                elementToReplace.innerHTML = sectionHTML;
              } else {
                mainCartItems.innerHTML = mainCartSection;
              }
            }
            
            // Update cart footer using helper function
            const mainCartFooter = document.getElementById('main-cart-footer');
            if (mainCartFooter && freshHtml.sections && freshHtml.sections[mainCartFooter.dataset.id]) {
              const footerSection = freshHtml.sections[mainCartFooter.dataset.id];
              updateCartFooter(mainCartFooter, footerSection);
            }
          }
          
          // Trigger cart update events
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: freshHtml } }));
          if (typeof window.publish !== 'undefined') {
            window.publish('cart-updated', freshHtml);
          }
        });
      } else {
        // If API call fails, reload the page
        window.location.reload();
      }
    } catch (error) {
      console.error('Cart refresh error:', error);
      // Fallback: reload page if refresh fails
      window.location.reload();
    }
  }

  // ----- Pairing helpers -----
  function findCareForMain(mainKey, mainVariantId, domCpId) {
    // Only look for care plans if this main product actually has a care plan
    const mainElement = q(`[data-key="${cssEscape(mainKey)}"]`);
    if (!mainElement) return null;
    
    // Check if this main product has care plan properties
    const hasCarePlanProperty = mainElement.classList.contains('main_product') && 
                               mainElement.getAttribute('cp-id');
    
    if (!hasCarePlanProperty) {
      // This main product doesn't have a care plan, don't look for one
      return null;
    }
    
    // 1) by variant id
    if (mainVariantId) {
      const byVariant = q(
        `[data-main-variant="${cssEscape(mainVariantId)}"].cp_product`
      );
      if (byVariant) return byVariant;
    }
    // 2) by m-id on CP (CP has m-id = main line key)
    if (mainKey) {
      const byMid = q(`.cp_product[m-id="${cssEscape(mainKey)}"]`);
      if (byMid) return byMid;
    }
    // 3) by cp-id attribute stored on MAIN (cp-id = CP line key)
    if (domCpId) {
      const byKey = q(`.cp_product[data-key="${cssEscape(domCpId)}"]`);
      if (byKey) return byKey;
    }
    return null;
  }

  function findMainForCare(careMainVariant, domMainIdOnCP) {
    // 1) by variant id
    if (careMainVariant) {
      const byVariant = q(
        `.main_product[data-main-variant="${cssEscape(careMainVariant)}"]`
      );
      if (byVariant) return byVariant;
    }
    // 2) by main line key that CP stored in m-id
    if (domMainIdOnCP) {
      const byKey = q(`.main_product[data-key="${cssEscape(domMainIdOnCP)}"]`);
      if (byKey) return byKey;
    }
    return null;
  }

  // ----- Engraving helpers -----
  function findEngravingForMain(mainKey, mainVariantId, domEngId) {
    // Only look for engraving products if this main product actually has engraving
    const mainElement = q(`[data-key="${cssEscape(mainKey)}"]`);
    if (!mainElement) return null;
    
    // Check if this main product has engraving properties
    const hasEngravingProperty = mainElement.classList.contains('main_product') && 
                                 mainElement.getAttribute('eng-id');
    
    if (!hasEngravingProperty) {
      // This main product doesn't have engraving, don't look for one
      return null;
    }
    
    // 1) by eng-id attribute stored on MAIN (eng-id = engraving line key) - most specific
    if (domEngId) {
      const byKey = q(`.eng_product[data-key="${cssEscape(domEngId)}"]`);
      if (byKey) return byKey;
    }
    // 2) by m-id on engraving (engraving has m-id = main line key)
    if (mainKey) {
      const byMid = q(`.eng_product[m-id="${cssEscape(mainKey)}"]`);
      if (byMid) return byMid;
    }
    // 3) by variant id (least specific - may match multiple engraving products)
    if (mainVariantId) {
      const byVariant = q(
        `[data-main-variant="${cssEscape(mainVariantId)}"].eng_product`
      );
      if (byVariant) return byVariant;
    }
    return null;
  }

  function findMainForEngraving(engMainVariant, domMainIdOnEng) {
    // 1) by variant id
    if (engMainVariant) {
      const byVariant = q(
        `.main_product[data-main-variant="${cssEscape(engMainVariant)}"]`
      );
      if (byVariant) return byVariant;
    }
    // 2) by main line key that engraving stored in m-id
    if (domMainIdOnEng) {
      const byKey = q(`.main_product[data-key="${cssEscape(domMainIdOnEng)}"]`);
      if (byKey) return byKey;
    }
    return null;
  }

  function getDrawer() {
    return (
      document.querySelector("cart-drawer") ||
      document.querySelector("cart-notification") ||
      null
    );
  }

  async function renderCart() {
    const cartEl = getDrawer();
    const isCartPage = window.location.pathname === '/cart';
    
    if (cartEl?.getSectionsToRender) {
      const sections = cartEl.getSectionsToRender().map((s) => s.id);
      const res = await originalFetch("/?sections=" + sections.join(","), {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      if (res.ok && cartEl.renderContents) {
        const html = await res.clone().json();
        cartEl.renderContents(html);
      }
    } else if (isCartPage) {
      // For cart page, use refreshCartUI instead of basic cart.js
      await refreshCartUI(cartEl);
    } else {
      const cartRes = await originalFetch("/cart.js", {
        credentials: "same-origin",
      });
      const cartData = await cartRes.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cartData } })
      );
      document.dispatchEvent(
        new CustomEvent("cart:refresh", { detail: { cart: cartData } })
      );
    }
  }

  async function changeQty(itemKey, qty) {
    return await originalFetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: itemKey, quantity: qty }),
    });
  }

  function parseBody(body) {
    if (!body) return {};
    if (typeof body === "string") {
      try {
        return JSON.parse(body);
      } catch {
        const out = {};
        body.split("&").forEach((p) => {
          const [k, v] = p.split("=");
          out[decodeURIComponent(k)] = decodeURIComponent(
            (v || "").replace(/\+/g, " ")
          );
        });
        if (out.quantity != null) out.quantity = Number(out.quantity);
        if (out.line != null) out.line = Number(out.line);
        return out;
      }
    } else if (body instanceof FormData) {
      const out = {};
      for (const [k, v] of body.entries()) out[k] = v;
      if (out.quantity != null) out.quantity = Number(out.quantity);
      if (out.line != null) out.line = Number(out.line);
      return out;
    }
    return {};
  }

  // ---------- fetch patch ----------
  window.fetch = async function (resource, config) {
    const url = typeof resource === "string" ? resource : resource?.url || "";

    // Normalize /cart/add so mains always carry a "Care Plan" prop
    if (url.includes("/cart/add")) {
      try {
        let bodyObj = parseBody(config?.body);

        // JSON bulk add
        if (bodyObj?.items) {
          bodyObj.items = bodyObj.items.map((it) => {
            if (!it.properties) it.properties = {};
            if (typeof it.properties["Care Plan"] === "undefined") {
              it.properties["Care Plan"] = null;
            }
            return it;
          });
          config.body = JSON.stringify(bodyObj);
        }

        // FormData single add
        if (config?.body instanceof FormData) {
          if (!config.body.has("properties[Care Plan]")) {
            config.body.append("properties[Care Plan]", "");
          }
        }
      } catch (e) {
        console.warn("Care Plan add normalization error:", e);
      }
      return originalFetch.apply(this, arguments);
    }

    // Only handle /cart/change below (both with and without .js)
    if (!url.includes("/cart/change")) {
      return originalFetch.apply(this, arguments);
    }

    try {
      const body = parseBody(config?.body);

      // Find the line element the theme targeted
      const selector = body?.line
        ? `[data-line-number="${body.line}"]`
        : body?.id
        ? `[data-key="${body.id}"]`
        : null;

      const lineEl = selector ? q(selector) : null;
      if (!lineEl) {
        return originalFetch.apply(this, arguments);
      }

      // Identify product type - check both class and attributes
      // Main product can be identified by: main_product class OR having eng-id/cp-id attributes
      const hasMainClass = lineEl.classList.contains("main_product");
      const hasEngIdAttr = !!lineEl.getAttribute("eng-id");
      const hasCpIdAttr = !!lineEl.getAttribute("cp-id");
      const isMain = hasMainClass || hasEngIdAttr || hasCpIdAttr;
      
      const isCP = lineEl.classList.contains("cp_product");
      const isEng = lineEl.classList.contains("eng_product");
      const qty = Number(body?.quantity ?? 0);

      const mainKey = lineEl.getAttribute("data-key");
      const mainLineNumber = lineEl.dataset.index || lineEl.getAttribute("data-line-number");
      const domCpId = lineEl.getAttribute("cp-id");
      const domMainIdOnCP = lineEl.getAttribute("m-id");
      const domEngId = lineEl.getAttribute("eng-id");
      const domMainIdOnEng = lineEl.getAttribute("m-id");
      const mainVariantId = lineEl.getAttribute("data-main-variant");

      // ---------- CASE 1: Main product removed → handle care plans, engraving, and paired products ----------
      if (isMain && qty === 0) {
        // Check if this is a care plan main product
        let cpKey = null;
        let cpLineNumber = null;
        
        // Only look for care plan if this main product actually has one
        const hasCarePlanProperty = lineEl.classList.contains('main_product') && 
                                   lineEl.getAttribute('cp-id');
        
        if (hasCarePlanProperty) {
          const cpLineEl = findCareForMain(mainKey, mainVariantId, domCpId);
          cpKey = cpLineEl?.getAttribute("data-key");
          cpLineNumber = cpLineEl?.dataset.index || cpLineEl?.getAttribute("data-line-number");
        }

        // Check if this is an engraving main product
        let engKey = null;
        
        // Only look for engraving if this main product actually has one
        // Check by eng-id attribute (more reliable than class, works in both cart page and drawer)
        const hasEngravingProperty = !!lineEl.getAttribute('eng-id');
        
        if (hasEngravingProperty) {
          const engLineEl = findEngravingForMain(mainKey, mainVariantId, domEngId);
          engKey = engLineEl?.getAttribute("data-key");
          
          // Fallback: if helper didn't find it but we have domEngId, use it directly
          // domEngId is the engraving product's key stored in eng-id attribute on main product
          if (!engKey && domEngId) {
            engKey = domEngId;
          }
        }

        // Check if this is a paired product
        const pairedWithProperty = lineEl.getAttribute("data-property");
        let pairedProductKey = null;
        
        if (pairedWithProperty) {
          const currentProductName = lineEl.querySelector('.pr_name')?.textContent?.trim() || 
                                     lineEl.querySelector('.cart-item__name')?.textContent?.trim();
          pairedProductKey = findPairedProduct(mainKey, currentProductName, pairedWithProperty);
        }

        const cartEl = getDrawer();
        const isCartPage = window.location.pathname === '/cart';
        
        // Get sections to render based on context - prioritize cart page
        let sections = [];
        if (isCartPage) {
          // For cart page, include main cart sections (prioritize cart page over cart drawer)
          sections = ['main-cart-items', 'cart-icon-bubble'];
          const mainCartFooter = document.getElementById('main-cart-footer');
          if (mainCartFooter?.dataset.id) {
            sections.push(mainCartFooter.dataset.id);
          }
        } else if (cartEl?.getSectionsToRender) {
          sections = cartEl.getSectionsToRender().map((s) => s.id);
        }

        // Remove main product first, then care plan to avoid line number conflicts
        // This prevents the care plan key from becoming invalid after main product removal
        
        let res;
        
        // First remove the main product
        res = await originalFetch(
          "/cart/change.js" + (sections.length ? "?sections=" + sections.join(",") : ""),
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: config?.credentials || "same-origin",
            body: JSON.stringify({
              line: mainLineNumber,
              quantity: 0,
            }),
          }
        );

        // Then remove the care plan if it exists
        if (cpKey && cpLineNumber && res.ok) {
          try {
            res = await originalFetch(
              "/cart/change.js" + (sections.length ? "?sections=" + sections.join(",") : ""),
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: config?.credentials || "same-origin",
                body: JSON.stringify({
                  line: cpLineNumber,
                  quantity: 0,
                }),
              }
            );
            
            if (!res.ok) {
              console.warn('Failed to remove care plan:', cpLineNumber, res.status, res.statusText);
              const errorText = await res.text();
              console.warn('Care plan error response:', errorText);
            }
          } catch (error) {
            console.warn('Care Plan patch: Failed to remove care plan', error);
            // Continue with the main product removal even if care plan removal fails
          }
        }

        // Then remove the engraving product if it exists
        // Use id (key) instead of line number since line numbers may have shifted after main product (and care plan) removal
        if (engKey && res.ok) {
          try {
            res = await originalFetch(
              "/cart/change.js" + (sections.length ? "?sections=" + sections.join(",") : ""),
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: config?.credentials || "same-origin",
                body: JSON.stringify({
                  id: engKey,
                  quantity: 0,
                }),
              }
            );
            
            if (!res.ok) {
              console.warn('Failed to remove engraving product:', engKey, res.status, res.statusText);
            }
          } catch (error) {
            console.warn('Engraving patch: Failed to remove engraving product', error);
            // Continue with the main product removal even if engraving removal fails
          }
        }

        // Check if main product removal was successful
        if (!res.ok) {
          console.error('Failed to remove main product:', mainLineNumber, res.status, res.statusText);
          const errorText = await res.text();
          console.error('Error response:', errorText);
          return res; // Return the error response
        }

        if (res.ok) {
          // If this was a paired product, also clear the paired properties
          if (pairedProductKey) {
            await originalFetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: config?.credentials || "same-origin",
              body: JSON.stringify({
                id: pairedProductKey,
                properties: { 
                  "Paired Product": null,
                  "Paired with": null 
                },
              }),
            });
            
            // Refresh cart to show cleared properties
            setTimeout(() => {
              const isCartPage = window.location.pathname === '/cart';
              if (isCartPage) {
                // For cart page, use proper section requests
                const sectionsToRequest = ['cart-icon-bubble'];
                const mainCartItems = document.getElementById('main-cart-items');
                if (mainCartItems?.dataset.id) {
                  sectionsToRequest.push(mainCartItems.dataset.id);
                }
                const mainCartFooter = document.getElementById('main-cart-footer');
                if (mainCartFooter?.dataset.id) {
                  sectionsToRequest.push(mainCartFooter.dataset.id);
                }
                
                fetch(`/cart/update.js?sections=${sectionsToRequest.join(',')}`, {
                  method: "GET",
                  headers: { "Content-Type": "application/json" },
                  credentials: "same-origin"
                })
                .then((response) => response.json())
                .then((freshHtml) => {
                  // Update main cart items
                  if (mainCartItems && freshHtml.sections && freshHtml.sections[mainCartItems.dataset.id]) {
                    const mainCartSection = freshHtml.sections[mainCartItems.dataset.id];
                    const cartItemsElement = document.querySelector('cart-items');
                    if (cartItemsElement?.getSectionInnerHTML) {
                      const sectionHTML = cartItemsElement.getSectionInnerHTML(mainCartSection, '.js-contents');
                      const elementToReplace = mainCartItems.querySelector('.js-contents') || mainCartItems;
                      elementToReplace.innerHTML = sectionHTML;
                    } else {
                      mainCartItems.innerHTML = mainCartSection;
                    }
                  }
                  
                  // Update cart footer
                  if (mainCartFooter && freshHtml.sections && freshHtml.sections[mainCartFooter.dataset.id]) {
                    const footerSection = freshHtml.sections[mainCartFooter.dataset.id];
                    mainCartFooter.innerHTML = footerSection;
                  }
                  
                  // Trigger cart update events
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: freshHtml } }));
                  if (typeof window.publish !== 'undefined') {
                    window.publish('cart-updated', freshHtml);
                  }
                })
                .catch((e) => {
                  console.error('Cart page update error:', e);
                  window.location.reload();
                });
              } else {
                refreshCartUI(cartEl);
              }
            }, 50);
          } else {
            // Normal cart refresh for non-paired products
          if (sections.length && cartEl?.renderContents) {
            const html = await res.clone().json();
            cartEl.renderContents(html);
            } else if (isCartPage) {
              // For cart page, use proper section requests
              const sectionsToRequest = ['cart-icon-bubble'];
              const mainCartItems = document.getElementById('main-cart-items');
              if (mainCartItems?.dataset.id) {
                sectionsToRequest.push(mainCartItems.dataset.id);
              }
              const mainCartFooter = document.getElementById('main-cart-footer');
              if (mainCartFooter?.dataset.id) {
                sectionsToRequest.push(mainCartFooter.dataset.id);
              }
              
              const freshCartResponse = await originalFetch(`/cart/update.js?sections=${sectionsToRequest.join(',')}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "same-origin"
              });
              
              if (freshCartResponse.ok) {
                const freshHtml = await freshCartResponse.json();
                
                // Update main cart items
                if (mainCartItems && freshHtml.sections && freshHtml.sections[mainCartItems.dataset.id]) {
                  const mainCartSection = freshHtml.sections[mainCartItems.dataset.id];
                  const cartItemsElement = document.querySelector('cart-items');
                  if (cartItemsElement?.getSectionInnerHTML) {
                    const sectionHTML = cartItemsElement.getSectionInnerHTML(mainCartSection, '.js-contents');
                    const elementToReplace = mainCartItems.querySelector('.js-contents') || mainCartItems;
                    elementToReplace.innerHTML = sectionHTML;
                  } else {
                    mainCartItems.innerHTML = mainCartSection;
                  }
                }
                
                // Update cart footer
                if (mainCartFooter && freshHtml.sections && freshHtml.sections[mainCartFooter.dataset.id]) {
                  const footerSection = freshHtml.sections[mainCartFooter.dataset.id];
                  mainCartFooter.innerHTML = footerSection;
                }
                
                // Trigger cart update events
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: freshHtml } }));
                if (typeof window.publish !== 'undefined') {
                  window.publish('cart-updated', freshHtml);
                }
              } else {
                window.location.reload();
              }
          } else {
            await renderCart();
            }
          }
        }
        return res;
      }

      // ---------- CASE 1.5: Paired product removed → clear paired properties ----------
      if (qty === 0) {
        const pairedWithProperty = lineEl.getAttribute("data-property");
        
        if (pairedWithProperty) {
          const currentProductName = lineEl.querySelector('.pr_name')?.textContent?.trim() || 
                                     lineEl.querySelector('.cart-item__name')?.textContent?.trim();
          const pairedProductKey = findPairedProduct(mainKey, currentProductName, pairedWithProperty);

          if (pairedProductKey) {
            const cartEl = getDrawer();
            const isCartPage = window.location.pathname === '/cart';
            
            // Get sections to render based on context - prioritize cart page
            let sections = [];
            if (isCartPage) {
              // For cart page, include main cart sections (prioritize cart page over cart drawer)
              sections = ['main-cart-items', 'cart-icon-bubble'];
              const mainCartFooter = document.getElementById('main-cart-footer');
              if (mainCartFooter?.dataset.id) {
                sections.push(mainCartFooter.dataset.id);
              }
            } else if (cartEl?.getSectionsToRender) {
              sections = cartEl.getSectionsToRender().map((s) => s.id);
            }

            // Remove the paired product using individual /cart/change.js request
            // This avoids line number conflicts when multiple products are in cart
            const res = await originalFetch(
              "/cart/change.js" + (sections.length ? "?sections=" + sections.join(",") : ""),
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: config?.credentials || "same-origin",
                body: JSON.stringify({
                  line: mainLineNumber,
                  quantity: 0,
                }),
              }
            );

            if (res.ok) {
              // Clear the paired properties from the paired product
              await originalFetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: config?.credentials || "same-origin",
                body: JSON.stringify({
                  id: pairedProductKey,
                  properties: { 
                    "Paired Product": null,
                    "Paired with": null 
                  },
                }),
              });
              
              // Refresh cart to show cleared properties
              setTimeout(() => {
                const isCartPage = window.location.pathname === '/cart';
                if (isCartPage) {
                  // For cart page, use proper section requests
                  const sectionsToRequest = ['cart-icon-bubble'];
                  const mainCartItems = document.getElementById('main-cart-items');
                  if (mainCartItems?.dataset.id) {
                    sectionsToRequest.push(mainCartItems.dataset.id);
                  }
                  const mainCartFooter = document.getElementById('main-cart-footer');
                  if (mainCartFooter?.dataset.id) {
                    sectionsToRequest.push(mainCartFooter.dataset.id);
                  }
                  
                  fetch(`/cart/update.js?sections=${sectionsToRequest.join(',')}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    credentials: "same-origin"
                  })
                  .then((response) => response.json())
                  .then((freshHtml) => {
                    // Update main cart items
                    if (mainCartItems && freshHtml.sections && freshHtml.sections[mainCartItems.dataset.id]) {
                      const mainCartSection = freshHtml.sections[mainCartItems.dataset.id];
                      const cartItemsElement = document.querySelector('cart-items');
                      if (cartItemsElement?.getSectionInnerHTML) {
                        const sectionHTML = cartItemsElement.getSectionInnerHTML(mainCartSection, '.js-contents');
                        const elementToReplace = mainCartItems.querySelector('.js-contents') || mainCartItems;
                        elementToReplace.innerHTML = sectionHTML;
                      } else {
                        mainCartItems.innerHTML = mainCartSection;
                      }
                    }
                    
                    // Update cart footer
                    if (mainCartFooter && freshHtml.sections && freshHtml.sections[mainCartFooter.dataset.id]) {
                      const footerSection = freshHtml.sections[mainCartFooter.dataset.id];
                      mainCartFooter.innerHTML = footerSection;
                    }
                    
                    // Trigger cart update events
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: freshHtml } }));
                    if (typeof window.publish !== 'undefined') {
                      window.publish('cart-updated', freshHtml);
                    }
                  })
                  .catch((e) => {
                    console.error('Cart page update error:', e);
                    window.location.reload();
                  });
                } else {
                  refreshCartUI(cartEl);
                }
              }, 50);
            }
            return res;
          }
        }
      }

      // ---------- CASE 2: Main qty changed → sync ONLY its Care ----------
      if (isMain && qty > 0) {
        const res = await originalFetch.apply(this, arguments);

        if (res.ok) {
          // re-grab fresh main (DOM rerendered)
          const freshMain = q(`.main_product[data-key="${cssEscape(mainKey)}"]`);
          const freshVariant =
            freshMain?.getAttribute("data-main-variant") || mainVariantId;

          // Only look for care plan if this main product actually has one
          const hasCarePlanProperty = freshMain?.classList.contains('main_product') && 
                                     freshMain?.getAttribute('cp-id');
          
          if (hasCarePlanProperty) {
            // Prefer direct cp-id on MAIN if present
            const cpKeyFromMain = freshMain?.getAttribute("cp-id") || null;
            let cpKey = cpKeyFromMain;

            // If not present, fall back to search
            if (!cpKey) {
          const freshCp = findCareForMain(mainKey, freshVariant, domCpId);
              cpKey = freshCp?.getAttribute("data-key") || null;
            }

          if (cpKey) {
              await changeQty(cpKey, qty);
              await renderCart();
            }
          }
        }
        return res;
      }

      // ---------- CASE 3: Care removed → clear main's property ----------
      if (isCP && qty === 0) {
        const careVariantBind = lineEl.getAttribute("data-main-variant");
        const cpKeySelf = lineEl.getAttribute("data-key");

        // First, find MAIN by cp-id == this CP's key (most reliable in mixed states)
        let relatedMain =
          q(`.main_product[cp-id="${cssEscape(cpKeySelf)}"]`) ||
          findMainForCare(careVariantBind, domMainIdOnCP) ||
          null;

        const relatedMainKey = relatedMain?.getAttribute("data-key");

        // Only proceed if we found a related main product
        if (relatedMainKey) {
          // Get current cart to preserve existing properties
          const cartResponse = await originalFetch("/cart.js", {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: config?.credentials || "same-origin",
          });
          
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            const mainItem = cartData.items.find(item => item.key === relatedMainKey);
            
            if (mainItem) {
              // Build properties object preserving all existing properties
              const updatedProperties = {};
              
              // Copy all existing properties except the one we're clearing
              if (mainItem.properties) {
                Object.keys(mainItem.properties).forEach(key => {
                  if (key !== "Care Plan") {
                    updatedProperties[key] = mainItem.properties[key];
                  }
                });
              }
              
              // Set Care Plan to null to clear it
              updatedProperties["Care Plan"] = null;
              
              await originalFetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: config?.credentials || "same-origin",
                body: JSON.stringify({
                  id: relatedMainKey,
                  properties: updatedProperties,
                }),
              });
            }
          }
        }

        return originalFetch.apply(this, arguments);
      }

      // ---------- CASE 4: Engraving removed → clear main's property ----------
      if (isEng && qty === 0) {
        const engVariantBind = lineEl.getAttribute("data-main-variant");
        const engKeySelf = lineEl.getAttribute("data-key");

        // Find MAIN product using multiple methods (most reliable first)
        let relatedMain = null;
        
        // Method 1: Use m-id attribute directly (should always work if set correctly)
        if (domMainIdOnEng) {
          relatedMain = q(`.main_product[data-key="${cssEscape(domMainIdOnEng)}"]`) ||
                        q(`[data-key="${cssEscape(domMainIdOnEng)}"]`);
        }
        
        // Method 2: Find by eng-id on main product (main product has eng-id = this engraving's key)
        if (!relatedMain) {
          relatedMain = q(`.main_product[eng-id="${cssEscape(engKeySelf)}"]`);
        }
        
        // Method 3: Use helper function with variant matching
        if (!relatedMain) {
          relatedMain = findMainForEngraving(engVariantBind, domMainIdOnEng);
        }

        const relatedMainKey = relatedMain?.getAttribute("data-key");

        // First, clear the property from the main product (same pattern as CASE 3)
        if (relatedMainKey) {
          // Get current cart to preserve existing properties
          const cartResponse = await originalFetch("/cart.js", {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: config?.credentials || "same-origin",
          });
          
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            const mainItem = cartData.items.find(item => item.key === relatedMainKey);
            
            if (mainItem) {
              // Build properties object preserving all existing properties
              const updatedProperties = {};
              
              // Copy all existing properties except the one we're clearing
              if (mainItem.properties) {
                Object.keys(mainItem.properties).forEach(key => {
                  if (key !== "Laser Engraving") {
                    updatedProperties[key] = mainItem.properties[key];
                  }
                });
              }
              
              // Set Laser Engraving to null to clear it
              updatedProperties["Laser Engraving"] = null;
              
              await originalFetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: config?.credentials || "same-origin",
                body: JSON.stringify({
                  id: relatedMainKey,
                  properties: updatedProperties,
                }),
              });
              
              // Small delay to ensure property update has been processed
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
        }

        // Then remove the engraving product - the response will include sections and trigger natural cart update
        return originalFetch.apply(this, arguments);
      }


      // Default: pass through
      return originalFetch.apply(this, arguments);
    } catch (err) {
      console.warn("Care Plan patch error:", err);
      return originalFetch.apply(this, arguments);
    }
  };
})();

// Fix for cart page freeze: Ensure freeze-causing classes are removed on page load
document.addEventListener('DOMContentLoaded', function() {
  const isCartPage = window.location.pathname === '/cart';
  if (isCartPage) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const isCartDrawerActive = cartDrawerWrapper && cartDrawerWrapper.classList.contains('active');
    
    // Remove freeze-causing classes if cart drawer is not active
    if (!isCartDrawerActive) {
      const freezeClasses = ['of_hidden', 'tingle-enabled', 'modal-open', 'popup-open'];
      freezeClasses.forEach(className => {
        document.documentElement.classList.remove(className);
        document.body.classList.remove(className);
      });
    }
  }
});